/**
 * Created by Vladislav on 19.09.2024.
 */

cleverapps.InitByFeature["regime_knockout"] = function () {
    cleverapps.tutorial.register(KnockoutTutorial());
};